export const parseCookieValue = value => {
  if (value == null || value === '') {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

export const hasAuthPayload = (name, value) => {
  if (name === 'token') {
    return Boolean(value?.hash);
  }
  return Boolean(value);
};

/** Collect every raw value for `name` from a cookie header (duplicate names are browser-specific). */
export const parseAllRawCookieValues = (
  name,
  cookieHeader = typeof document !== 'undefined' ? document.cookie : '',
) => {
  if (!cookieHeader) {
    return [];
  }
  return cookieHeader
    .split(/;\s*/)
    .map(part => {
      const idx = part.indexOf('=');
      if (idx === -1) {
        return null;
      }
      const key = part.slice(0, idx).trim();
      if (key !== name) {
        return null;
      }
      const raw = part.slice(idx + 1);
      try {
        return decodeURIComponent(raw);
      } catch {
        return raw;
      }
    })
    .filter(Boolean);
};

export const readAuthCookieFromDocument = (name, cookieHeader) => {
  for (const raw of parseAllRawCookieValues(name, cookieHeader)) {
    const parsed = parseCookieValue(raw);
    if (hasAuthPayload(name, parsed)) {
      return parsed;
    }
  }
  return null;
};

export const hasValidTokenRaw = raw => {
  if (!raw) {
    return false;
  }
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return Boolean(parsed?.hash);
  } catch {
    return false;
  }
};
